import React from "react";
import { Search, Sun, Moon } from "lucide-react";
import { Input } from "@/components/ui/input";
import { useTheme } from "@/lib/theme";

export const TopHeader = ({ search, onSearch, title }) => {
  const { theme, toggle } = useTheme();

  return (
    <header className="sticky top-0 z-20 flex h-16 w-full items-center justify-between gap-4 border-b border-border bg-background/80 px-6 backdrop-blur-md">
      <h2 className="hidden text-lg font-bold tracking-tight sm:block">{title}</h2>

      <div className="relative w-full max-w-md">
        <Search className="pointer-events-none absolute left-3 top-1/2 h-4 w-4 -translate-y-1/2 text-muted-foreground" />
        <Input
          value={search}
          onChange={(e) => onSearch(e.target.value)}
          placeholder="Search apps..."
          data-testid="search-input"
          className="h-10 rounded-full border-border bg-card pl-9 focus-visible:ring-2 focus-visible:ring-primary/50"
        />
      </div>

      <button
        onClick={toggle}
        data-testid="theme-toggle"
        className="flex h-10 w-10 items-center justify-center rounded-full border border-border bg-card text-muted-foreground transition-colors duration-200 hover:text-foreground"
        aria-label="Toggle theme"
      >
        {theme === "dark" ? <Sun className="h-5 w-5" /> : <Moon className="h-5 w-5" />}
      </button>
    </header>
  );
};
